import { render, staticRenderFns } from "./change-appoint.vue?vue&type=template&id=4a304412"
import script from "./change-appoint.vue?vue&type=script&lang=js"
export * from "./change-appoint.vue?vue&type=script&lang=js"
import style0 from "./change-appoint.vue?vue&type=style&index=0&id=4a304412&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports